import cn from 'classnames';
import { Plan } from 'api-bible-shared-lib/utils/types';

import Pill from './Pill';
import { IconCheck } from './Icons';
import { getPlanPriceLabel } from '../utils/plans';
import { usePlans } from '../contexts/Plans';

interface PlanCardProps {
  planId: string;
  plan: Plan;
  disabled?: boolean;
  className?: string;
  children?: React.ReactNode;
  onSelect?: (plan: string) => void;
}

export default function PlanCard({
  planId,
  plan,
  disabled = false,
  className,
  children,
  onSelect,
}: PlanCardProps) {
  const { plansById } = usePlans();

  const planColor = plansById[planId].color;
  const { name, label, description, features, prices } = plan;
  const priceLabel = getPlanPriceLabel(prices);
  const buttonLabel = disabled ? (
    'Coming Soon!'
  ) : (
    <>
      {children} {name}
    </>
  );
  return (
    <div
      className={cn(
        'p-6 border-2 rounded-xl flex flex-col justify-between',
        {
          'border-dashed opacity-60': disabled,
          'shadow-none hover:shadow-2xl transition-shadow transition-transform ease-out duration-300 transform hover:scale-105':
            !disabled,
        },
        className,
      )}
      style={{ borderColor: planColor }}
    >
      <div>
        <div className="flex justify-end mb-4">
          <Pill className="text-white" color={planColor}>
            {label}
          </Pill>
        </div>

        <div className="flex items-center mb-3">
          <h3 className="text-4xl font-black mr-0.5">{priceLabel.amount}</h3>
          <span className="text-lg text-gray-500 bold">{priceLabel.unit}</span>
        </div>

        <h2 className="mb-4 text-3xl font-bold capitalize bold" style={{ color: planColor }}>
          {name}
        </h2>

        <p className="mb-4 text-sm max-w-3/4">{description}</p>

        <ul className="mb-4">
          {features.split(/\r?\n/).map((feature) => (
            <li className="flex mb-2 items-top" key={feature}>
              <div className="relative inline-block w-5 h-5 mt-px mr-1">
                <div
                  className="absolute inset-0 rounded-full opacity-20"
                  style={{ background: planColor }}
                />
                <IconCheck className="w-5 h-5" style={{ color: planColor }} />
              </div>
              {feature}
            </li>
          ))}
        </ul>
      </div>
      <div>
        <button
          style={{ background: planColor }}
          className={cn('w-full py-2 text-lg text-center text-white rounded-lg', {
            'cursor-not-allowed': disabled,
          })}
          onClick={() => (onSelect && !disabled ? onSelect(planId) : '')}
          disabled={disabled}
          type="button"
        >
          {buttonLabel}
        </button>
      </div>
    </div>
  );
}
